module.exports = __webpack_public_path__ + "static/img/performance_6.5ba6f9a7.jpg";